import React from 'react';

/** מעטפת גלילה פנימית גנרית */
const PageScroll: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  className = '',
  children,
}) => {
  return (
    <div className={`page-scroll ${className}`} role="region" tabIndex={-1}>
      {children}
    </div>
  );
};

export default PageScroll;
